import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { ConfirmMessageComponent } from "./confirm-message/confirm-message.component";
import { ContactFormComponent } from "./contact-form/contact-form.component";
import { ContactTempComponent } from "./contact-temp/contact-temp.component";
import { ListMessageComponent } from "./list-message/list-message.component";
import { SingleMessageComponent } from "./single-message/single-message.component";

    const contactRoutes: Routes = [
        { path: 'contact', component: ContactTempComponent },
//     { path: 'contact/confirm', component: ConfirmMessageComponent },
//     { path: 'contact/list-messages', component: ListMessageComponent },
//     { path: 'contact/message/:id' ,component:SingleMessageComponent }
    ];

@NgModule({
    imports: [
        RouterModule.forChild(contactRoutes)
    ],
    exports: [
        RouterModule
    ]
})
export class ContactRoutingModule { }
